<template>
  <div>
    <div class="file-box" v-if="!uploaded">
        <div class="demo">
            <p>
              点击<el-button type="text" @click="downloadTempalate('report')">下载《2024 GBC Report Template》</el-button>
            </p>
            <p>
              点击<el-button type="text" @click="downloadTempalate('ppt')">下载《2024 GBC PPT Template》</el-button>
            </p>
            <!-- <p>
              点击<el-button type="text" @click="downloadTempalate('anli')">下载《案例》</el-button>
            </p>
            <p>
              点击<el-button type="text" @click="downloadTempalate('timu')">下载《案例题目》</el-button>
            </p> -->
           
             <!-- <div class="tip">
                *报告仅限提交一次
            </div> -->
              
           
      </div>
      <h1 class="upload-title">团队报告提交</h1>
      <el-upload
        ref="uploadFile"
        class="upload-demo"
        :action="imgHost + '/user/upload'"
        :headers="uploadHeader"
        :on-preview="handlePreview"
        :data="uploadData"
        multiple
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList"
        auto-upload
        :on-success="uploadSuccess"
        :before-upload="beforeAvatarUpload"
        accept=".doc,.docx,.pdf"
      > 
        <el-button size="small" type="primary">点击上传</el-button>
        <template #tip>
          <div class="el-upload__tip">只能上传word文件或pdf文件，文件命名：校名（中文）+队名， （例：重庆工商大学龙之梦队）</div>
        </template>
      </el-upload>
      <div class="team-button-box">
        <!-- <el-button class="pre">上一步</el-button> -->
        <el-button class="next" size="small" type="primary" @click="next">提交</el-button>
      </div>
      <div class="bg-box">
        <img src="../../assets/images/team/bg.png" alt="">
      </div>
    </div>
    <div class="status-box" v-else>
        <div class="img-box">
            <img src="../../assets/images/team/submit.png" alt="">
            <p>报告已提交成功</p>
            <!-- <el-button class="next">下一步</el-button> -->
        </div>
    </div>
  </div>
</template>

<script>
import {
  apiSetProcess,
  apiGetProcess
}from '../../plugins/apis'
export default {
  data() {
    return {
      imgHost:process.env.VUE_APP_API_URL,
      uploadHeader:{ Authorization: window.localStorage.app_token },
      fileList: [],
      uploadData:{},
      processData:{},
      uploaded:false,
    };
  },
  mounted(){
    this.uploadData = {
      file_source:1
    }
    this.getView()
  },
  props:['round','label'],
  watch:{
    'label'(){
      this.getView()
    }
  },
  methods: { 
    beforeAvatarUpload(file) { 
      let fileArr = file.name.split('.')
      let bul = ['doc','docx','pdf'].indexOf(fileArr.pop()) > -1
      if(bul) {
        return true;
      }else{
        this.$message.error('只能上传word文件或pdf文件')
        return false
      }
    },
    downloadTempalate(flag){
      switch(flag){
        case "report":
        window.open("http://api.gbc.cncima.com/download?path="+encodeURIComponent("/storage/2024 GBC Report Template.docx"));
          // window.open('http://api.gbc.cncima.com/storage/CGMA%20GBC2022%E5%9B%A2%E9%98%9F%E6%8A%A5%E5%91%8A%E6%A8%A1%E6%9D%BF.docx')
          break;
        case "ppt":
          window.open("http://api.gbc.cncima.com/download?path="+encodeURIComponent("/storage/2024 GBC PPT Template.pptx"));
          // window.open('http://api.gbc.cncima.com/storage/GBC2022%20%20PPT%20template%2016-9.pptx')
          break;
        case "anli":
          window.open("http://api.gbc.cncima.com/download?path="+encodeURIComponent("/storage/GBC Case.pdf"));
          // window.open('http://api.gbc.cncima.com/storage/GBC%20Case.pdf')
          break;
        case "timu":
          window.open("http://api.gbc.cncima.com/download?path="+encodeURIComponent("/storage/Questions_Mainland China Final.pdf"));

          // window.open('http://api.gbc.cncima.com/storage/Questions_Mainland%20China%20Final.pdf')
          break;
      }
    },
    async getView(){
      let res = await apiGetProcess(this.round.round_id,this.label)
      if(res.code === 200){
        this.uploaded = res.data ? true:false
      }
    },
    async next(){
      
      if(this.processData.file_id === undefined || this.processData.file_id === '' || !this.processData.file_id){
        this.$message.error('请上传文件')
        return
      }
      this.$confirm('报告仅限提交一次, 确认提交吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let r = await apiSetProcess(this.round.round_id,this.label,this.processData)
          if(r.code === 500){
            this.$message.error(r.message)
            return
          }
          await this.getView()
          this.$Bus.$emit('reload_NowProcess');
          this.$message({
            type: 'success',
            message: '提交成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消提交'
          });          
        });
      
    },
    uploadSuccess(e){
      if(e.code === 200){
        this.$message.success('上传成功')
        this.processData = {
          file_id:e.data.file_id,
        }
      }else[
        this.$message.error('上传失败')
      ]
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed() {
      this.fileList = []
      this.$refs.uploadFile.submit()
      // this.$message.warning(
      //   `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
      //     files.length + fileList.length
      //   } 个文件`
      // );
    }, 
  },
};
</script>

<style>
  .upload-title{
    padding: 20px 0;
  }
  .demo{
   margin-bottom: 15px;
    width: 100%;
    border: 1px dashed #733085;
    border-radius: 5px;
    padding: 10px 20px;
    display: flex;
    flex-wrap: wrap;
    text-align: left;
  }
  .demo p{
    width: 50%;
    font-size: 14px;
  }
  .demo .el-button{
    color: #733085;
  }
  .demo .tip{
    margin-top: 20px;
    width: 100%;
    text-align: right;
    color: #733085;
    font-size: 12px;
  }
  .upload-title{
    font-size: 16px;
    /* color: #733085; */
    font-weight: 600;

  }
  @media screen and (max-width: 767px){
      .demo p{
        width: 100%;
      }
     
  }
  @media screen and (max-width: 320px){
     .demo{
        padding: 10px 10px;
      }
  }
  .bianan span{
    color: #909399;
  }
</style>